import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import Play from '@material-ui/icons/PlayArrow';
import Radio from '@material-ui/core/Radio';
import DotIcon from '@material-ui/icons/Lens';
import Collapse from '@material-ui/core/Collapse';
import ListItem from '@material-ui/core/ListItem';
import Typography from '@material-ui/core/Typography';
import ListItemText from '@material-ui/core/ListItemText';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';

import ghaPickupStatusStyles from './ghaPickupStatus.module.css';

const styles = (theme: Theme) =>

  createStyles({
    root: {
      minHeight: 40,
      width: '85%'
    },
    cursor: {
      cursor: 'pointer',
    },
    nested: {
      display: 'flex',
      justifyContent: 'flex-start',
      padding: 0,
      width: '60%',
      transform: 'scale(0.8)',
    },
    play: {
      marginTop: 20,
      color: 'var(--primaryblue)',
      marginLeft: '-4px'
    },
    playRotate: {
      transform: 'rotate(90deg)'
    },
    ListItem: {
      borderBottom: '1px solid rgba(224, 224, 224, 1)',
      paddingBottom: 5,
      fontSize: '0.8125rem'
    },
    ListItemText: {
      fontSize: '0.8125rem'
    },
    dotIconCommon: {
      fontSize: 14,
      position: 'absolute',
      top: 20,
      right: 35
    },
    green: {
      color: 'green',
    },
    red: {
      color: 'red'
    },
    radioYes: {
      marginRight: 50
    }
  });

interface GhaAwbCustomClearanceStatusProps {
  classes: any;
  handleExpandChange: (expandType: string, forceOpen?: boolean) => void;
  expandComponent: boolean;
  componentChecked: { yes: boolean; no: boolean; };
  updateStatus: (event: React.ChangeEvent<HTMLInputElement>) => void;
  updateCustomsClearance: boolean;
};

const ghaAwbCustomClearanceStatus = (props: GhaAwbCustomClearanceStatusProps) => {

  const { classes } = props;
  const dotStatusClasses: string = [classes.dotIconCommon, props.componentChecked.yes? classes.green : classes.red].join(' ');

  return (

    <div className={ ghaPickupStatusStyles.mainWrapper } >
      { props.expandComponent
        ? <Play className={ [classes.play, classes.playRotate, classes.cursor ].join(' ') } onClick={ () => props.handleExpandChange('customsClearance') } />
        : <Play className={ [classes.play, classes.cursor].join(' ') } onClick={ () => props.handleExpandChange('customsClearance') } />
      }
      <List
        component="nav"
        aria-labelledby="nested-list-subheader"
        className={ classes.root }
      >
        <DotIcon className={ dotStatusClasses } />
        <ListItem className={ classes.ListItem } >
          <ListItemText classes={{ primary: classes.ListItemText }} primary='Customs Clearance'/>
        </ListItem>

        <Collapse in={ props.expandComponent } timeout="auto" unmountOnExit >
          <List component="time" disablePadding >

            <ListItem className={ classes.nested }>

              <FormControlLabel  
                labelPlacement="end" 
                label={ <Typography className={ classes.green }>Yes</Typography> }
                className={ classes.green }
                control={
                  <Radio
                    checked={ props.componentChecked.yes }
                    onChange={ props.updateStatus }
                    value={ 'yes' }
                    name='radio-button'
                    checkedIcon={ <RadioButtonCheckedIcon className={ classes.green } /> }
                    disabled={ !props.updateCustomsClearance }
                    className={ classes.green }
                  />
                }
              />
              <FormControlLabel  
                labelPlacement="end" 
                label={ <Typography className={ classes.red }>No</Typography> }
                className={ classes.red }
                control={
                  <Radio
                    checked={ props.componentChecked.no }
                    onChange={ props.updateStatus }
                    value={ 'no' }
                    name='radio-button'
                    checkedIcon={ <RadioButtonCheckedIcon className={ classes.red } /> }
                    disabled={ !props.updateCustomsClearance }
                    className={ classes.red }
                  />
                }
              />

            </ListItem>

          </List>
        </Collapse>

      </List>
    </div>
  );
};

export default withStyles(styles)(ghaAwbCustomClearanceStatus);